import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ROOT_PATHS } from '../../Constants';
import AgProgressTabs from '../../stories/AgProgressTabs';
import { useIntl } from 'react-intl';
import AgTypography from '../../stories/Styles/AgTypography';
import OrganizationInfo from '../OrganizationInfo';
import { useAppSelector } from '../../redux/hooks';
import { selectFullProfile } from '../../redux/slices/fullProfile';
import StaffInfo from '../StaffInfo';

const AccountPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const messages = useIntl().formatMessage;
  const profile = useAppSelector(selectFullProfile);
  const orgId = profile?.organizations?.[0]?.id;
  const staffId = profile?.account?.id;

  /** Determine active tab based on current path */
  const activeTab = location.pathname?.includes(ROOT_PATHS.MY_ORGANISATION) ? 'org' : 'profile';

  const tabItems = [
    {
      id: '1',
      title: messages({ id: 'PROFILE_TAB_LABEL' }),
      subTitle: messages({ id: 'PROFILE_TAB_DESCRIPTION' }),
      isActive: activeTab === 'profile',
      onClick: () => navigate(ROOT_PATHS.ACCOUNT + ROOT_PATHS.PROFILE),
    },
    {
      id: '2',
      title: messages({ id: 'MY_ORGANIZATION' }),
      subTitle: messages({ id: 'ORGANIZATION_TAB_DESCRIPTION' }),
      isActive: activeTab === 'org',
      onClick: () => navigate(ROOT_PATHS.ACCOUNT + ROOT_PATHS.MY_ORGANISATION),
    },
  ];

  return (
    <AgTypography
      style={{
        display: 'flex',
        gap: '8px',
        justifyContent: 'start',
        padding: '16px 32px',
        minHeight: '100%',
      }}
    >
      <AgTypography style={{ flex: 1 }}>
        <AgProgressTabs
          items={tabItems}
          sx={{
            maxWidth: '1104px',
            boxSizing: 'border-box',
            marginBottom: '10px',
          }}
        />

        <Routes>
          {/* Make the profile the default route */}
          <Route path='/' element={<Navigate to={ROOT_PATHS.ACCOUNT + ROOT_PATHS.PROFILE} replace />} />
  
          {/* Wrap the profile and organization routes with the AccountPage path */}
          <Route path={ROOT_PATHS.PROFILE} element={
            <StaffInfo staffId={Number(staffId)} isProfile />
          } />
          <Route path={ROOT_PATHS.MY_ORGANISATION} element={
            <OrganizationInfo orgId={orgId} />
          } />
        </Routes>
      </AgTypography>
    </AgTypography>
  );
};

export default AccountPage;
